import { downloadFile } from '@/common/copyright/fileUtil'
import TsaCreateProcess from '@/components/copyright/business/copyrightDetail/createProcess'
import { draftSearchApi, draftFindDramaStageDraftListApi, draftFindStageFilesApi, draftDeleteApi } from '@/api/copyright/draft'
import { apiDramaCategorySearchList } from '@/api/copyright/common'
import tableConfig from '@/config/copyright/tableConfig'
import { categorysList } from '@/config/copyright/categorysList'
import { mapState, mapActions } from 'vuex'
export default {
    components: {
        TsaCreateProcess
    },
    data () {
        return {
            loading: true,
            condition: {
                page: 1,
                size: tableConfig['pageSize'],
                // 名称或描述'
                nameOrDescription: '',
                // 权利人
                owner: '',
                // 申请账号ID
                applyUserId: '',
                createdAt: [], // startCreatedAt endCreatedAt
                // 剧集类型（0短剧 1漫剧）
                category: null,
            },
            list: [],
            categorysList,
            categoryList: [],
        }
    },
    computed: {
        ...mapState({
            userInfo: (state) => state.userInfo.me,
            
        }),
    },
    mounted () {
        this.init()
    },
    methods: {
        resetFilter () {
            this.condition = {
                page: 1,
                size: tableConfig['pageSize'],
                // 名称或描述
                nameOrDescription: '',
                // 权利人
                owner: '',
                // 申请人
                applyUserId: '',
                createdAt: [],
                category: null,
            }
            this.init('refresh')
        },
        serarch(){
            this.condition.page = 1
            this.init('refresh')
        },
        ...mapActions({
            updateDraftBoxCount: 'app/updateDraftBoxCount',
        }),
        command (val, item) {
            switch (val) {
                case 'gotoDetail':
                    this.gotoDetail(item)
                    break
                case 'deleteFun':
                    this.deleteFun(item)
                    break
            }
        },
        scroll () {
            this.reset()
        },
        reset () {
           this.list.map((item, index) => {
                this.$refs.myDropdown[index] && this.$refs.myDropdown[index].hide()
           }) 
        },
        refresh () {
            this.reset()
            //console.log('refresh')
            this.$refs.TsaPullToRefresh.setRefreshLoading(true)
            this.$refs.TsaPullToRefresh.setFinished(false)
            this.condition.page = 1
            this.init('refresh')
        },
        load () {
            console.log('load')
            this.condition.page++
            this.$refs.TsaPullToRefresh.setMoreLoading(true)
            this.init('load')
        },
        init (type) {
            if (type === 'refresh') {
                this.$TsaLoadingV2.show()
            }
            // 通用版权
            this.loading = true
            let condition = JSON.parse(JSON.stringify(this.condition))
            // 通用版权
            condition.type = -1
            draftSearchApi(condition).then((res) => {
                this.$TsaLoadingV2.hide()
                if (res.code === 200) {
                    let data = res.data && res.data.data ? res.data.data : []
                    if (type === 'refresh') {
                        this.list = data
                        this.$refs.TsaPullToRefresh.setRefreshLoading(false)
                        this.$toast.clear()
                    } else {
                        this.list = [ ...this.list, ...data, ]
                    }
                    this.$nextTick(() => {
                        // 数据已经全部加载完成
                        if (data.length < this.condition.size) {
                            this.$refs.TsaPullToRefresh.setFinished(true)
                        }
                        this.$refs.TsaPullToRefresh.setMoreLoading(false)
                    })
                } else {
                    if (type === 'refresh') {
                        this.$refs.TsaPullToRefresh.setRefreshLoading(false)
                    } else {
                        this.condition.page--
                        this.$refs.TsaPullToRefresh.setMoreLoading(false)
                    }
                }
            }).catch((err) => {
                this.$TsaLoadingV2.hide()
                if (type === 'refresh') {
                    this.$refs.TsaPullToRefresh.setRefreshLoading(false)
                } else {
                    this.condition.page--
                    this.$refs.TsaPullToRefresh.setMoreLoading(false)
                }
            });  
        },
        // 继续编辑
        gotoDetail ({ id, userId, account, type }) {
            // 此处不能全等
            if (this.userInfo.id != userId) {
                return this.$TsaToastV2.show({
                    message: `该作品由子账号「${account}」申请，请联系他继续完成认证`,
                    type: 'error',
                })
            }
            // 通用版权内部跳转
            if (type === 0) {
                this.$router.push({
                    path: '/copyright/index',
                    query: {
                        id,
                        redirect:'false'
                    }
                })
            } else {
                this.$router.push({
                    path: '/copyright/drama',
                    query: {
                        id
                    }
                })
                //window.open(`${process.env.VUE_APP_COPYRIGHT}/drama/index?id=${id}`)
            }
            UserEventRecord.track(UserEventRecord.trackCommonCopyrightDraftOperation, {
                '操作类型': '继续认证'
            })
        },
        // 删除
        deleteFun ({ id, userId, account }) {
            // 此处不能全等
            // if (this.userInfo.id != userId) {
            //     return this.$TsaToastV2.show({
            //                 message: `该作品由子账号「${account}」申请，请联系他继续完成认证`,
            //                 type: 'error',
            //             })
            // }
            UserEventRecord.track(UserEventRecord.trackCommonCopyrightDraftOperation, {
                '操作类型': '删除作品'
            })
            this.$TsaConfirmV2.show({
                title: '提示',
                // type: 'success', // warn success
                message: '删除后您填写的信息将被清空且无法恢复，确定删除么',
                confirmButtonText: '确定删除',
                onConfirm: ($vm) => {
                    $vm.loading = true
                    draftDeleteApi({
                        ids: [id]
                    }).then((res) => {
                        $vm.loading = false
                        this.$TsaConfirmV2.hide()
                        this.condition.page = 1
                        this.updateDraftBoxCount()
                        //this.resetExpansion()
                        this.init('refresh')
                        UserEventRecord.track(UserEventRecord.trackCommonCopyrightDraftOperation, {
                            '操作类型': '删除作品成功'
                        })
                    }).catch(() => {
                        $vm.loading = false
                    })
                }
            })
        },
    }
}